import { NotificationButton } from '@avanta/shared/components/chat/NotificationButton';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { Headset } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { SUPPORTER_ID } from 'constants/chat';
import { ROUTES } from 'constants/routes';
import { useUserStore } from 'stores/user';

interface SupportButtonProps {
  className?: string;
  onAfterClick?: () => void;
}

export const SupportButton = ({
  className,
  onAfterClick,
}: SupportButtonProps): React.ReactElement | null => {
  const navigate = useNavigate();
  const { t } = useTranslation(LOCIZE_NS.COMMON);
  const isPsychologist = useUserStore(state => state.isPsychologist);
  const isSupporter = useUserStore(state => state.isSupporter);
  const shouldRenderSupportButton = !isPsychologist && !isSupporter;

  if (!shouldRenderSupportButton) return null;

  const handleSupport = (): void => {
    navigate(ROUTES.CHAT, { state: { support: true } });
    onAfterClick?.();
  };

  return (
    <NotificationButton
      variant="terciary"
      size="md"
      className={className}
      onClick={handleSupport}
      icon="leading"
      notificationUserId={SUPPORTER_ID}
    >
      <Headset className="size-5" />
      <p className="text-xs">{t('Nav.support')}</p>
    </NotificationButton>
  );
};
